import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { BasicSectionTitle } from 'Components/Blocks/Titles'
import { Column } from 'Components/UI'

import { LANDING_CONTENT_PX, LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

import CheckboxList from './CheckboxList'
import Statistic from './Statistic'

type Props = {
  onAction?: () => void
}

function GrowSection({ onAction }: Props) {
  return (
    <SectionContainer px={LANDING_CONTENT_PX}>
      <AppearingWrapper centered>
        <Column
          fullWidth
          gap={10}
          maxWidth={LANDING_CONTENT_WIDTH_PX}
          pt={[4, 4, 4, 4, 17]}
        >
          <BasicSectionTitle
            buttonCaption="Contact Us"
            plainText="Take your business from the boardroom to the fairways."
            subtitle="Emajin Golf’s Business Networking offers a truly unique experience unlike any other corporate forum."
            title="grow"
            onClick={onAction}
          />

          <CheckboxList />

          <Statistic />
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default GrowSection
